<div class="snackbar-content">
  <div class="icon error">
    <mat-icon style="color: #b84848;">close</mat-icon>
  </div>
  <span>{{ data.message }}</span>

  <mat-icon
    class="close-icon"
    (click)="close()"
    style="color: #8395A5; cursor: pointer;"
    >close</mat-icon
  >
</div>
